// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/delete_project_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/delete_project_image.proto.
 */
export const file_vision_assets_v1_delete_project_image: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vYXNzZXRzL3YxL2RlbGV0ZV9wcm9qZWN0X2ltYWdlLnByb3RvEhdwcm90b3MudmlzaW9uLmFzc2V0cy52MSKWAQoZRGVsZXRlUHJvamVjdEltYWdlUmVxdWVzdBJJCgZwYXJhbXMYASABKAsyOS5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5EZWxldGVQcm9qZWN0SW1hZ2VSZXF1ZXN0LlBhcmFtcxouCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghpbWFnZV9pZBgCIAEoCSJyChpEZWxldGVQcm9qZWN0SW1hZ2VSZXNwb25zZRJKCgZyZXN1bHQYASABKAsyOi5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5EZWxldGVQcm9qZWN0SW1hZ2VSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.assets.v1.DeleteProjectImageRequest
 */
export type DeleteProjectImageRequest = Message<"protos.vision.assets.v1.DeleteProjectImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteProjectImageRequest.Params params = 1;
   */
  params?: DeleteProjectImageRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteProjectImageRequest.
 * Use `create(DeleteProjectImageRequestSchema)` to create a new message.
 */
export const DeleteProjectImageRequestSchema: GenMessage<DeleteProjectImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_project_image, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteProjectImageRequest.Params
 */
export type DeleteProjectImageRequest_Params = Message<"protos.vision.assets.v1.DeleteProjectImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteProjectImageRequest.Params.
 * Use `create(DeleteProjectImageRequest_ParamsSchema)` to create a new message.
 */
export const DeleteProjectImageRequest_ParamsSchema: GenMessage<DeleteProjectImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_project_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteProjectImageResponse
 */
export type DeleteProjectImageResponse = Message<"protos.vision.assets.v1.DeleteProjectImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteProjectImageResponse.Result result = 1;
   */
  result?: DeleteProjectImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteProjectImageResponse.
 * Use `create(DeleteProjectImageResponseSchema)` to create a new message.
 */
export const DeleteProjectImageResponseSchema: GenMessage<DeleteProjectImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_project_image, 1);

/**
 * @generated from message protos.vision.assets.v1.DeleteProjectImageResponse.Result
 */
export type DeleteProjectImageResponse_Result = Message<"protos.vision.assets.v1.DeleteProjectImageResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.DeleteProjectImageResponse.Result.
 * Use `create(DeleteProjectImageResponse_ResultSchema)` to create a new message.
 */
export const DeleteProjectImageResponse_ResultSchema: GenMessage<DeleteProjectImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_project_image, 1, 0);

